import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/helpers';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  interactive?: boolean;
};

export default function Card({ className, interactive, ...props }: CardProps) {
  return <div className={cn('ui-card', interactive && 'ui-card--interactive', className)} {...props} />;
}

